import { render, staticRenderFns } from "./QcTestCreateFormulationPopUp.vue?vue&type=template&id=0a6a2734&scoped=true&"
import script from "./QcTestCreateFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./QcTestCreateFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./QcTestCreateFormulationPopUp.vue?vue&type=style&index=0&id=0a6a2734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a2734",
  null
  
)

export default component.exports